/** See the file "LICENSE" for the full license governing this code.
 *
 * @author Dale "Ducky" Lotts
 * @since 9/11/16.
 */

require('./src/js/datetimepicker');
require('./src/js/datetimepicker.templates');

module.exports = 'ui.bootstrap.datetimepicker';



//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-datetimepicker/index.js
// module id = 319
// module chunks = 0